<template>
	<div>
		<div id="content">
			<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Lists Admin">
				<p class="my-4">{{message}}</p>
			</b-modal>
			<div>
				<b-overlay :show="this.loading" rounded="sm">
					<div class="row">
						<h2>Lists</h2>
						<div class="col-md-3" >
							<b-form-select class="mb-2" v-model="selectedListDetails" :options="listOptions" @change="getList">
							</b-form-select>
						</div>
						<div v-if="this.selectedListDetails !== null">
							<div class="row">
								<div class="col-md-3" v-if="selectedListDetails">
									<div class="mt-3">
										<div v-if="list !== null"> 
											<h2>{{list.length + " "  + selectedListDetails.displayName}}</h2>
										</div>
										<b-form-input class="mb-2" v-model="search" placeholder="search..."></b-form-input>
										<div class="col-md-9" v-for="i in searchList" :key="i.id">
											<div @click="selectItem(i)">
												<p>{{i.name}}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-5" v-if="item">
									<div class="m-5 mt-0">
										<div v-for="(value, propertyName) in item" :key="propertyName">
											<div v-if="propertyName==='id'"> 
												<small>guid: {{item.id}}</small>
											</div>
											<div v-else>
												{{propertyName}}:
												<b-form-input class="mb-2" v-model="item[propertyName]"></b-form-input>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="m-5 mt-0">
										<div class="row mb-1">
											<b-button @click="saveItem()" variant="primary"><b-icon-cloud-arrow-up font-scale="1.5"/> Save Item</b-button>
										</div>
										<div v-if="this.item != null && this.item.id === ''"> 
											<div class="row mb-1">
												<b-button @click="cancelNewItem()" variant="danger"><b-icon-trash font-scale="1.5"/> Cancel</b-button>
											</div>
										</div>
										<div v-else>
											<div class="row mb-1" v-if="this.selectedListDetails.editOnly == false">
												<b-button @click="deleteItem()" variant="danger"><b-icon-trash font-scale="1.5"/> Delete Item</b-button>
											</div>
										</div>
										<div class="row mb-1" v-if="this.selectedListDetails.editOnly == false">
											<b-button @click="newItemPressed()" variant="success"><b-icon-plus-circle font-scale="1.5"/> New Item</b-button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-else class="col-md-4">
							<p>All the world is made of faith, and trust, and pixie dust. </p>
							<p>Welcome to all the various lists of our app. Changes you make to these lists affect the lists customers see in the app. Use this page with care. You can perform the following actions:</p>
							<ul>
								<li><span style="font-weight: bold"> Add an item</span>  </li>
								<li><span style="font-weight: bold"> Edit an item</span></li>
								<li><span style="font-weight: bold"> Delete an item</span></li>
							</ul>
							<h2>now, select a list...</h2>
						</div>
					</div>
				</b-overlay>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  name: 'Lists',
  data() {
	return {
		selectedListDetails: null,
		list: null,
		item: null,
		search: null,
		loading: false,
		message: null,
		error: null,
		listOptions: [
			{ value: null, text: 'Please select an option', disabled: true },
			{ value: {route: "InsuranceProviders", displayName: "Insurance Providers", editOnly: false}, text: "Insurance Providers" },
			{ value: {route: "InvestmentProviders", displayName: "Investment Providers", editOnly: false}, text: "Investment Providers" },
			{ value: {route: "CreditProviders", displayName: "Credit Providers", editOnly: false}, text: "Credit Providers" },
			{ value: {route: "InvestmentTypes", displayName: "Investment Types", editOnly: false}, text: "Investment Types" },
			{ value: {route: "CreditTypes", displayName: "Credit Types", editOnly: false}, text: "Credit Types" },
			{ value: {route: "PolicyTypes", displayName: "Insurance Policy Types", editOnly: false}, text: "Insurance Policy Types" },
			// { value: {route: "Moods", displayName: "Moods"}, text: "Moods" },
			{ value: {route: "Banks", displayName: "Banks"}, text: "Banks", editOnly: false},
			{ value: {route: "BankAccountTypes", displayName: "Bank Account Types", editOnly: true}, text: "Bank Account Types" },
			// { value: {route: "GoalCategories", displayName: "Goal Categories"}, text: "Goal Categories" },
		]
	}
  },
  computed: {
		searchList: function() {
			if (this.search==null || this.search=="") { return this.list; }
			return this.list.filter((n) => n.name.toLowerCase().includes(this.search.toLowerCase()));
		}
  },
  methods: {
	selectItem: function(i) {
		this.item = i;
	},
	saveItem: function() {
		this.loading = true;
		if (this.item.id == "") {
			delete this.item.id;
			this.$http.post(this.$config.ApiUri + `/${this.selectedListDetails.route}`, this.item)
				.then((result) => {
					this.selectItem(result.data);
					this.getListRequest(true);
					this.showMessage("Item created OK!");
				}
			).catch(() => { this.showError(); })
			.finally(() => {this.loading = false;} );
		} else {
			this.$http.put(this.$config.ApiUri + `/${this.selectedListDetails.route}/${this.item.id}`, this.item)
				.then((result) => {
					this.selectItem(result.data);
					this.getListRequest(false);
					this.showMessage("Item saved OK!");
				}
			).catch(() => { this.showError(); })
			.finally(() => {this.loading = false;} );
		}
	},
	deleteItem: function() {
		this.$http.delete(this.$config.ApiUri + `/${this.selectedListDetails.route}/${this.item.id}`)
			.then((result) => {
				this.message = result;
				this.getListRequest(true);
				this.showMessage("Item deleted OK!");
			}
		).catch(() => { this.showError(); })
		.finally(() => {this.loading = false;} );
	},
	newItemPressed: function() {
		this.item = {};
		if (this.list.length > 0) {
			for (const property in this.list[0]) {
				this.item[property] = "";
			}
		}
		this.list.splice(0,0,this.item);
	},
	cancelNewItem: function() {
		this.list.splice(0,1);
		if (this.list.length > 0) {
			this.item = this.list[0];
		}
	},
	getList: function() {
		this.getListRequest(true);
	},
	getListRequest: function(autoSelect) {
		this.$http.get(this.$config.ApiUri + `/${this.selectedListDetails.route}`)
			.then((result) => {
				this.list = result.data;
					if(autoSelect) {
						if (this.list.length > 0) {
							this.selectItem(this.list[0]);
						}
					}
			}
		).catch(() => { this.showError(); })
		.finally(() => {this.loading = false;});
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact tech"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.modal-header .close {
  display:none;
}
</style>